import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "fetch-more-button-container"
}
const _hoisted_2 = {
  key: 2,
  class: "loading-animation"
}

import { ref } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import FormButton from '@/components/common/FormButton.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import AverageSearchForm from '@/components/forms/AverageSearchForm.vue'
import AverageSearchResults from '@/components/widgets/public/AverageSearchResults.vue'
import { useAveragesStore } from '@/store/public/averages'
import { getErrorMessage } from '@/utils/error-handling'


export default /*@__PURE__*/_defineComponent({
  __name: 'AverageView',
  setup(__props) {

const averages = useAveragesStore()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

async function fetch({ bowler, club }: { bowler: string; club: string }) {
  isLoading.value = true

  try {
    await averages.fetch(bowler, club)
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed searching for averages: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
}

async function fetchMore() {
  isLoading.value = true

  try {
    await averages.fetchMore()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching more results: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(AverageSearchForm, {
      "is-loading": isLoading.value,
      onSubmit: fetch
    }, null, 8, ["is-loading"]),
    (!isLoading.value && errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 0,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createVNode(AverageSearchResults),
    (!isLoading.value && _unref(averages).next)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(FormButton, {
            onClick: _withModifiers(fetchMore, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('averages.fetch-more')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BusyIndicator)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})